import { Avatar, Grid, Stack, Typography, useTheme } from "@mui/material";
import CoreCard from "../core/CoreCard";
import QuizIcon from "@mui/icons-material/Quiz";
import React from "react";

export interface FaqItem {
  question: string;
  answer: any;
}

interface Props {
  faqs: FaqItem[];
}

const Faq: React.FC<Props> = ({ faqs }) => {
  const theme = useTheme();
  return (
    <Grid container spacing={[3, 3, 5, 5]}>
      {faqs.map((faq) => (
        <Grid item md={6} xs={12} key={faq.question}>
          <CoreCard padding={4}>
            <Stack direction="row" spacing={2}>
              <Avatar sx={{ backgroundColor: theme.palette.secondary.main }}>
                <QuizIcon />
              </Avatar>
              <Stack>
                <Typography variant="body1" fontFamily="Open Sans Bold" color="primary">
                  {faq.question}
                </Typography>
                <Typography variant="body1">{faq.answer}</Typography>
              </Stack>
            </Stack>
          </CoreCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default Faq;
